import { render, staticRenderFns } from "./CustomerImportItems.vue?vue&type=template&id=595fd4ec"
import script from "./CustomerImportItems.vue?vue&type=script&lang=js"
export * from "./CustomerImportItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports